
import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for ArtistsCatalog Action/Mutation Types. Use it in   artists/actions.js, artists/mutations.js and the Vuex Host Component 
export const RecoupableList = createActionTypeModel('RecoupableList');
export const RecoupableData = createActionTypeModel('RecoupableData');

